import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {DoGeneralAICompletionType} from "./__graphql-types__/index.ts";

export const DO_GENERAL_AI_COMPLETION: GqlOperation<
    DoGeneralAICompletionType["response"],
    DoGeneralAICompletionType["variables"]
> = gqlOp(gql`
    mutation DoGeneralAICompletion(
        $prompt: String!
        $model: String
        $temperature: Float
        $maxTokens: Int
        $stop: [String!]
    ) {
        doGeneralAICompletion(
            input: {
                prompt: $prompt
                model: $model
                temperature: $temperature
                maxTokens: $maxTokens
                stop: $stop
            }
        ) {
            completion {
                text
            }
            error {
                code
            }
        }
    }
`);
